import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["connectingWarning", "registeringWarning"];
  static values = {
    connecting: Boolean,
    connectingDelay: { type: Number, default: 60000 },
    registering: Boolean,
    registeringDelay: { type: Number, default: 30000 },
  };

  connect() {
    this.connectingTimeout = this.armTimer(
      this.connectingValue && this.hasConnectingWarningTarget,
      this.connectingDelayValue,
      () => this.connectingWarningTarget,
    );
    this.registeringTimeout = this.armTimer(
      this.registeringValue && this.hasRegisteringWarningTarget,
      this.registeringDelayValue,
      () => this.registeringWarningTarget,
    );
  }

  disconnect() {
    clearTimeout(this.connectingTimeout);
    clearTimeout(this.registeringTimeout);
  }

  armTimer(active, delay, target) {
    if (!active) return undefined;

    return setTimeout(() => {
      target().classList.remove("hidden");
    }, delay);
  }
}
